"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const KeyStrokeFactory_1 = require("../../DOM/EventTarget/KeyStrokeFactory");
const KeyStrokeMatcher_1 = require("../../DOM/EventTarget/KeyStrokeMatcher");
EventTarget.prototype.addKeyListener = function addKeyListener(keys, listener, eventName) {
    eventName = eventName !== null && eventName !== void 0 ? eventName : 'keyup';
    let keyStrokes = null;
    this.addEventListener(eventName, (evt) => {
        // lazy load: parse keys only on the first key stroke
        if (keyStrokes === null) {
            keyStrokes = (Array.isArray(keys) ? keys : [keys]).map(value => KeyStrokeFactory_1.default.fromString(value));
        }
        for (const keyStroke of keyStrokes) {
            /* istanbul ignore if */
            if (keyStroke.key === null) {
                throw new Error('KeyStrokeFactory: Missing key for keystroke');
            }
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (listener !== null && KeyStrokeMatcher_1.default.matches(keyStroke, evt)) {
                listener(evt);
                return;
            }
        }
    });
};
//# sourceMappingURL=AddKeyListener.js.map